import { useState } from "react";
import { FaHeart, FaRegHeart, FaShareAlt } from "react-icons/fa";

export default function JobCard({
  title,
  company,
  location,
  onClick,
  buttonLabel,
  onSave,
  jobId,
  isSaved,
}) {
  const [copied, setCopied] = useState(false);

  const handleShare = () => {
    const jobUrl = `${window.location.origin}/job/${jobId}`;

    if (navigator.share) {
      navigator.share({
        title,
        text: `Check out this job at ${company}!`,
        url: jobUrl,
      });
    } else {
      navigator.clipboard.writeText(jobUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="border rounded-xl shadow-md p-4 flex flex-col justify-between hover:shadow-xl transition duration-300 bg-white hover:bg-indigo-50 border-l-4 border-indigo-500">
      <div>
        {copied && (
          <div
            className="fixed top-10 left-1/2 transform -translate-x-1/2 
                  bg-gradient-to-r from-indigo-500 to-purple-500  
                  text-white px-6 py-3 rounded-full shadow-lg 
                  text-sm font-semibold animate-bounce z-50"
          >
            ✅ Job link copied!
          </div>
        )}

        <h3 className="font-semibold text-lg text-indigo-700">{title}</h3>
        <p className="text-gray-600 font-medium">{company}</p>
        {location && <p className="text-gray-500 text-sm">{location}</p>}
      </div>

      <div className="flex justify-start gap-3 mt-4">
        {/* Save button */}
        <button
          onClick={() => onSave(jobId, !isSaved)}
          aria-label={isSaved ? "Unsave job" : "Save job"}
          className="text-xl"
        >
          {isSaved ? (
            <FaHeart className="text-red-500" />
          ) : (
            <FaRegHeart className="text-gray-500 hover:text-red-500" />
          )}
        </button>

        {/* Share button */}
        <button
          onClick={handleShare}
          aria-label="Share job"
          className="text-xl text-gray-500 hover:text-blue-500"
        >
          <FaShareAlt />
        </button>
      </div>

      <button
        onClick={onClick}
        className="mt-3 border px-3 py-1 rounded-md hover:bg-indigo-100 text-indigo-600 font-medium transition"
      >
        {buttonLabel}
      </button>
    </div>
  );
}
